"use client"

import { useState, useEffect } from "react"
import { Button } from "@/components/ui/button"
import { Card, CardContent } from "@/components/ui/card"
// import { Badge } from "@/components/ui/badge"
import { Check, Star } from "lucide-react"
import Image from "next/image"

// import InteractiveBuildSection from "@/components/interactive-build-section"
// import AnimatedHeroSection from "@/components/animated-hero-section"
// import FAQSection from "@/components/faq-section"
import { m, AnimatePresence } from "framer-motion"

import { CustompageLine as Icon_CustompageLine } from "@/components/customer/icons/CustompageLine";
import GlobalPartnersCount from "@/components/GlobalPartnersCount";
import { ReviewStar as Icon_ReviewStar } from "@/components/customer/icons/ReviewStar";
const SvgIcons = { CustompageLine: Icon_CustompageLine, ReviewStar: Icon_ReviewStar };


// import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion"
import TrustedPartners from "./TrustedPartners";
import StatsSection from "./StatusSection"
import FaqSection from "./FaqSection"
import { getImageUrl } from "@/lib/imageUrl"
import TestiReviewCommonImages from "./otherpages/TestiReviewCommonImages"

const steps = [
  {
    id: 1,
    title: "Our Core Solutions",
    isExpanded: true,
    icon:
      <svg xmlns="http://www.w3.org/2000/svg" className="md:w-[20px] w-[14px] md:h-[20px] h-[14px]" viewBox="0 0 20 20" fill="none">
        <g clipPath="url(#clip0_917_244)">
          <path d="M12.5 16.25H7.5C7.15456 16.25 6.875 16.5296 6.875 16.875V18.125C6.875 19.1589 7.71606 20 8.75 20H11.25C12.2839 20 13.125 19.1589 13.125 18.125V16.875C13.125 16.5296 12.8454 16.25 12.5 16.25Z" fill="#1558BC" />
          <path d="M9.99953 9.63627C11.1793 9.63627 12.1358 8.67984 12.1358 7.50002C12.1358 6.3202 11.1793 5.36377 9.99953 5.36377C8.81971 5.36377 7.86328 6.3202 7.86328 7.50002C7.86328 8.67984 8.81971 9.63627 9.99953 9.63627Z" fill="#1558BC" />
          <path d="M17.4312 6.46234C16.9875 3.13109 14.2312 0.437338 10.8875 0.0498377C8.74375 -0.200162 6.6 -0.200162 5.00625 1.89984C3.4125 3.32484 2.5 5.36234 2.5 7.49984C2.5 10.3123 4.05 12.8623 6.54375 14.1561C6.74375 14.2623 6.875 14.4748 6.875 14.7061V15.1123C7.06875 15.0373 7.28125 14.9998 7.5 14.9998H12.5C12.7188 14.9998 12.9312 15.0373 13.125 15.1123V14.7061C13.125 14.4748 13.25 14.2623 13.4563 14.1561C16.3 12.6811 17.8562 9.66234 17.4312 6.46234ZM13.75 8.12484H13.3259C13.2379 8.59415 13.0542 9.02978 12.7936 9.40971L13.0933 9.70934C13.3374 9.95346 13.3374 10.349 13.0933 10.5932C12.9712 10.7152 12.8113 10.7763 12.6514 10.7763C12.4915 10.7763 12.3316 10.7152 12.2095 10.5932L11.9099 10.2935C11.5299 10.5541 11.0943 10.7378 10.625 10.8258V11.2499C10.625 11.5953 10.3454 11.8749 10 11.8749C9.65456 11.8749 9.375 11.5953 9.375 11.2499V10.8258C8.90569 10.7378 8.47006 10.5541 8.09012 10.2935L7.7905 10.5932C7.66844 10.7152 7.5085 10.7763 7.34863 10.7763C7.18875 10.7763 7.02881 10.7152 6.90675 10.5932C6.66263 10.349 6.66263 9.95353 6.90675 9.70934L7.20638 9.40971C6.94581 9.02978 6.76213 8.59415 6.67406 8.12484H6.25C5.90456 8.12484 5.625 7.84527 5.625 7.49984C5.625 7.1544 5.90456 6.87484 6.25 6.87484H6.67406C6.76213 6.40553 6.94581 5.9699 7.20638 5.58996L6.90675 5.29034C6.66263 5.04621 6.66263 4.65071 6.90675 4.40653C7.15088 4.16234 7.54637 4.1624 7.79056 4.40653L8.09019 4.70615C8.47012 4.44559 8.90575 4.2619 9.37506 4.17384V3.74977C9.37506 3.40434 9.65462 3.12477 10.0001 3.12477C10.3455 3.12477 10.6251 3.40434 10.6251 3.74977V4.17384C11.0944 4.2619 11.53 4.44559 11.9099 4.70615L12.2096 4.40653C12.4537 4.1624 12.8492 4.1624 13.0934 4.40653C13.3376 4.65065 13.3375 5.04615 13.0934 5.29034L12.7937 5.58996C13.0543 5.9699 13.238 6.40553 13.3261 6.87484H13.7501C14.0956 6.87484 14.3751 7.1544 14.3751 7.49984C14.3751 7.84527 14.0954 8.12484 13.75 8.12484Z" fill="#1558BC" />
          <path d="M1.25 8.125H0.625C0.279563 8.125 0 7.84544 0 7.5C0 7.15456 0.279563 6.875 0.625 6.875H1.25C1.59544 6.875 1.875 7.15456 1.875 7.5C1.875 7.84544 1.59544 8.125 1.25 8.125Z" fill="#1558BC" />
          <path d="M3.81294 1.93802C3.653 1.93802 3.49312 1.87696 3.37106 1.7549L2.92919 1.31302C2.68506 1.0689 2.68506 0.673398 2.92919 0.429211C3.17331 0.185023 3.56881 0.185086 3.813 0.429211L4.25487 0.871086C4.499 1.11521 4.499 1.51071 4.25487 1.7549C4.13281 1.87696 3.97281 1.93802 3.81294 1.93802Z" fill="#1558BC" />
          <path d="M3.37106 14.7539C3.21112 14.7539 3.05125 14.6929 2.92919 14.5708C2.68506 14.3267 2.68506 13.9312 2.92919 13.687L3.37106 13.2451C3.61519 13.001 4.01069 13.001 4.25487 13.2451C4.49906 13.4892 4.499 13.8847 4.25487 14.1289L3.813 14.5708C3.69094 14.6929 3.53094 14.7539 3.37106 14.7539Z" fill="#1558BC" />
          <path d="M19.375 8.125H18.75C18.4046 8.125 18.125 7.84544 18.125 7.5C18.125 7.15456 18.4046 6.875 18.75 6.875H19.375C19.7204 6.875 20 7.15456 20 7.5C20 7.84544 19.7204 8.125 19.375 8.125Z" fill="#1558BC" />
          <path d="M16.1875 1.938C16.0275 1.938 15.8677 1.87694 15.7456 1.75488C15.5015 1.51075 15.5015 1.11525 15.7456 0.871062L16.1875 0.429188C16.4316 0.185063 16.8271 0.185063 17.0713 0.429188C17.3155 0.673312 17.3154 1.06881 17.0713 1.313L16.6294 1.75488C16.5073 1.87694 16.3473 1.938 16.1875 1.938Z" fill="#1558BC" />
          <path d="M16.6293 14.7539C16.4694 14.7539 16.3095 14.6929 16.1875 14.5708L15.7456 14.1289C15.5015 13.8848 15.5015 13.4893 15.7456 13.2451C15.9897 13.0009 16.3852 13.001 16.6294 13.2451L17.0713 13.687C17.3154 13.9311 17.3154 14.3266 17.0713 14.5708C16.9492 14.6929 16.7892 14.7539 16.6293 14.7539Z" fill="#1558BC" />
        </g>
        <defs>
          <clipPath id="clip0_917_244">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>,
    content: [
      "Web App Development",
      "Mobile App Development (iOS, Android, Cross-platform)",
      "Desktop Applications",
      "Cloud-Based Systems (AWS, Azure, GCP)",
    ],
    mockup: {
      type: "mobile",
      content: {
        title: "Get unlimited access to our programs.",
        subtitle: "Take the first step towards a healthier and happier life.",
        price: "$60.99",
        category: "Exercise Class",
      },
    },
  },
  {
    id: 2,
    title: "Industry-Specific Software",
    isExpanded: false,
    icon:
      <svg xmlns="http://www.w3.org/2000/svg" className="md:w-[20px] w-[14px] md:h-[20px] h-[14px]" viewBox="0 0 20 20" fill="none">
        <path fillRule="evenodd" clipRule="evenodd" d="M18.9577 5.00008C18.9577 3.95008 18.541 2.94341 17.7985 2.20091C17.056 1.45841 16.0493 1.04175 14.9993 1.04175H4.99935C3.94935 1.04175 2.94268 1.45841 2.20018 2.20091C1.45768 2.94341 1.04102 3.95008 1.04102 5.00008V15.0001C1.04102 16.0501 1.45768 17.0567 2.20018 17.7992C2.94268 18.5417 3.94935 18.9584 4.99935 18.9584H14.9993C16.0493 18.9584 17.056 18.5417 17.7985 17.7992C18.541 17.0567 18.9577 16.0501 18.9577 15.0001V5.00008ZM10.406 6.80258L8.40602 12.8026C8.29768 13.1301 8.47435 13.4842 8.80185 13.5934C9.12935 13.7017 9.48352 13.5251 9.59268 13.1976L11.5927 7.19758C11.701 6.87008 11.5244 6.51591 11.1968 6.40675C10.8693 6.29842 10.5152 6.47508 10.406 6.80258ZM12.5577 8.44175L14.1152 10.0001L12.5577 11.5584C12.3135 11.8017 12.3135 12.1984 12.5577 12.4417C12.801 12.6859 13.1977 12.6859 13.441 12.4417L15.441 10.4417C15.6852 10.1976 15.6852 9.80258 15.441 9.55842L13.441 7.55841C13.1977 7.31425 12.801 7.31425 12.5577 7.55841C12.3135 7.80175 12.3135 8.19842 12.5577 8.44175ZM6.55768 7.55841L4.55768 9.55842C4.31352 9.80258 4.31352 10.1976 4.55768 10.4417L6.55768 12.4417C6.80102 12.6859 7.19768 12.6859 7.44102 12.4417C7.68518 12.1984 7.68518 11.8017 7.44102 11.5584L5.88352 10.0001L7.44102 8.44175C7.68518 8.19842 7.68518 7.80175 7.44102 7.55841C7.19768 7.31425 6.80102 7.31425 6.55768 7.55841Z" fill="#1558BC" />
      </svg>,
    content: [
      "E-Commerce Platforms",
      "Healthcare Solutions",
      "FinTech Tools (Wallets, Lending, Investment)",
      "Logistics & Fleet Management",
      "Real Estate Platforms",
      "EdTech Solutions (LMS, Virtual Classes)",
      "ERP / CRM Software",
    ],
    mockup: {
      type: "cards",
      content: {
        cards: [
          { title: "EdTech", subtitle: "Digital Learning Tools Built for Engagement and Scale" },
          { title: "Healthcare", subtitle: "Powering Better Care with Custom HealthTech" },
          { title: "E-Commerce", subtitle: "Built to Sell. Customized to Scale." },
          { title: "Fintech", subtitle: "Secure. Scalable. FinTech That Moves Money Smarter" },
          {
            title: "Logistics & Fleet Solutions",
            subtitle:
              "Track fleets, optimize routes, manage shipments, and monitor driver performance — all in one intelligent dashboard.",
          },
        ],
      },
    },
  },
  {
    id: 3,
    title: "Specialized Systems",
    isExpanded: false,
    icon:
      <svg xmlns="http://www.w3.org/2000/svg" className="md:w-[20px] w-[14px] md:h-[20px] h-[14px]" viewBox="0 0 20 20" fill="none">
        <g clipPath="url(#clip0_917_275)">
          <path d="M19.9996 14.0672V12.074L18.0045 11.8627C17.8801 11.3526 17.6786 10.8726 17.4131 10.4359L18.6747 8.87545L17.2653 7.466L15.7048 8.72764C15.2681 8.46213 14.7882 8.26064 14.278 8.13619L14.0668 6.14111H12.0735L11.8622 8.13619C11.3521 8.26064 10.8721 8.46213 10.4354 8.72764L8.87496 7.466L7.46551 8.87545L8.72715 10.4359C8.46164 10.8726 8.26016 11.3526 8.1357 11.8627L6.14062 12.074V14.0672L8.1357 14.2785C8.26016 14.7886 8.46164 15.2686 8.72715 15.7053L7.46551 17.2658L8.87496 18.675L10.4354 17.4136C10.8721 17.6791 11.3521 17.8806 11.8622 18.005L12.0735 20.0001H14.0668L14.278 18.005C14.7882 17.8805 15.2681 17.679 15.7048 17.4135L17.2653 18.6752L18.6748 17.2657L17.4131 15.7053C17.6786 15.2685 17.8801 14.7886 18.0046 14.2785L19.9996 14.0672ZM13.0702 15.4056C11.7805 15.4056 10.7351 14.3602 10.7351 13.0706C10.7351 11.781 11.7805 10.7356 13.0702 10.7356C14.3598 10.7356 15.4052 11.781 15.4052 13.0706C15.4052 14.3602 14.3598 15.4056 13.0702 15.4056Z" fill="#1558BC" />
          <path d="M9.25699 4.46434C9.15988 4.06629 9.00266 3.69184 8.79551 3.35105L9.77992 2.13348L8.68016 1.03371L7.46258 2.01813C7.12184 1.81098 6.74734 1.65375 6.3493 1.55664L6.18449 0H4.62922L4.46438 1.55668C4.06633 1.65379 3.69187 1.81098 3.35109 2.01816L2.13352 1.03375L1.03375 2.13352L2.01816 3.35109C1.81102 3.69184 1.65379 4.06633 1.55668 4.46438L0 4.62918V6.18445L1.55668 6.3493C1.65379 6.74734 1.81098 7.1218 2.01816 7.46258L1.03375 8.68016L2.13352 9.77992L3.35109 8.79551C3.69184 9.00266 4.06633 9.15988 4.46438 9.25699L4.62922 10.8137H6.18449L6.33984 9.34648L5.8918 8.7923L6.63734 8.04676L8.0468 6.6373L8.7923 5.89176L9.34648 6.3398L10.8137 6.18445V4.62918L9.25699 4.46434ZM5.40684 7.22879C4.40059 7.22879 3.58488 6.41309 3.58488 5.40684C3.58488 4.40059 4.40059 3.58488 5.40684 3.58488C6.41309 3.58488 7.22879 4.40059 7.22879 5.40684C7.22879 6.41309 6.41309 7.22879 5.40684 7.22879Z" fill="#1558BC" />
        </g>
        <defs>
          <clipPath id="clip0_917_275">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>,
    content: [
      "Inventory & Warehouse Tools",
      "Accounting & Finance Software",
      "HR and Payroll Systems",
      "Project Management Tools",
      "Booking & Reservation Systems",
      "POS Systems for Retail & Hospitality",
    ],
    mockup: {
      type: "desktop",
      content: {
        title: "Vilva App",
        sections: [
          "Overview",
          "Payments",
          "Reviews",
          "Disputes",
          "Top-ups",
          "Check deposits",
          "Payouts",
          "All transactions",
          "Balances",
          "Customers",
          "Connected accounts",
          "Products",
          "Readers",
          "Reports",
          "Issued cards",
        ],
      },
    },
  },
  {
    id: 4,
    title: "Future-Tech Integration",
    isExpanded: false,
    icon:
      <svg xmlns="http://www.w3.org/2000/svg" className="md:w-[20px] w-[14px] md:h-[20px] h-[14px]" viewBox="0 0 20 20" fill="none">
        <path d="M8.30766 4.64742L8.80953 6.04117C9.36703 7.58805 10.5852 8.80617 12.132 9.36367L13.5258 9.86555C13.6514 9.91117 13.6514 10.0893 13.5258 10.1343L12.132 10.6362C10.5852 11.1937 9.36703 12.4118 8.80953 13.9587L8.30766 15.3524C8.26203 15.478 8.08391 15.478 8.03891 15.3524L7.53703 13.9587C6.97953 12.4118 5.76141 11.1937 4.21453 10.6362L2.82078 10.1343C2.69516 10.0887 2.69516 9.91055 2.82078 9.86555L4.21453 9.36367C5.76141 8.80617 6.97953 7.58805 7.53703 6.04117L8.03891 4.64742C8.08391 4.52117 8.26203 4.52117 8.30766 4.64742Z" fill="#1558BC" />
        <path d="M14.5824 1.29804L14.8368 2.00366C15.1193 2.78679 15.7362 3.40366 16.5193 3.68616L17.2249 3.94054C17.2887 3.96366 17.2887 4.05366 17.2249 4.07679L16.5193 4.33116C15.7362 4.61366 15.1193 5.23054 14.8368 6.01366L14.5824 6.71929C14.5593 6.78304 14.4693 6.78304 14.4462 6.71929L14.1918 6.01366C13.9093 5.23054 13.2924 4.61366 12.5093 4.33116L11.8037 4.07679C11.7399 4.05366 11.7399 3.96366 11.8037 3.94054L12.5093 3.68616C13.2924 3.40366 13.9093 2.78679 14.1918 2.00366L14.4462 1.29804C14.4693 1.23366 14.5599 1.23366 14.5824 1.29804Z" fill="#1558BC" />
        <path d="M14.5824 13.2812L14.8368 13.9868C15.1193 14.77 15.7362 15.3868 16.5193 15.6693L17.2249 15.9237C17.2887 15.9468 17.2887 16.0368 17.2249 16.06L16.5193 16.3143C15.7362 16.5968 15.1193 17.2137 14.8368 17.9968L14.5824 18.7025C14.5593 18.7662 14.4693 18.7662 14.4462 18.7025L14.1918 17.9968C13.9093 17.2137 13.2924 16.5968 12.5093 16.3143L11.8037 16.06C11.7399 16.0368 11.7399 15.9468 11.8037 15.9237L12.5093 15.6693C13.2924 15.3868 13.9093 14.77 14.1918 13.9868L14.4462 13.2812C14.4693 13.2175 14.5599 13.2175 14.5824 13.2812Z" fill="#1558BC" />
      </svg>,
    content: [
      "AI & ML-Driven Features",
      "Chatbots & Virtual Assistants",
      "Blockchain-Powered Applications",
      "IOT-Based Software and Dashboards",
    ],
    mockup: {
      type: "chat",
      content: {
        title: "Your Future Tech is Here!",
        messages: [
          { text: "Hello.. Folks", sender: "bot" },
          { text: "Best Custom Product Agency?", sender: "user" },
          { text: "I have one solution..", sender: "bot" },
        ],
      },
    },
  },
]

export default function CustomSoftware() {
  const projects = [
    {
      title: "Vilva One Web",
      desc: "Book your bus tickets & Order your groceries within a second",
      highlight: "Improved business performance by 50% with faster",
      img: getImageUrl("/vilvabusiness/website/products/growsuite/vilvaoneweb.webp"),
    },
    {
      title: "Caps Finserve - Investment Planner",
      desc: "Transforming investment management into a seamless digital experience.",
      highlight: "Improved client ROI by 55% through data-driven insights",
      img: getImageUrl("/vilvabusiness/website/products/growsuite/vilvaoneweb.webp"),
    },
    {
      title: "Vilva One App",
      desc: "Everything you need, right on time.",
      highlight: "Increased usage by 30% and streamlined “Book & Order” experience.",
      img: getImageUrl("/vilvabusiness/website/products/growsuite/vilvaoneapp.webp"),
    },
    {
      title: "Ecommerce Dashboard",
      desc: "Modern and minimal design solutions for job referrals and application tracking..",
      highlight: "60% faster order processing, 3x more leads",
      img: getImageUrl("/vilvabusiness/website/products/growsuite/printvally.webp"),
    },
    {
      title: "Print Vally Dashboard",
      desc: "Empowering teams to manage every print job with ease",
      highlight: "Reduced manual effort by 60% and improved workflow accuracy by 40% with an intuitive dashboard.",
      img: getImageUrl("/vilvabusiness/website/products/growsuite/printvally.webp"),
    },
    {
      title: "Growsuite Call Log App",
      desc: "Mini CRM for smarter call management.",
      highlight: "Enhanced CRM performance by 65%",
      img: getImageUrl("/vilvabusiness/website/products/growsuite/growsuite.webp"),
    },
  ];

  const [activeStep, setActiveStep] = useState(1)
  const [isAutoPlaying, setIsAutoPlaying] = useState(true)

  useEffect(() => {
    if (!isAutoPlaying) return

    const interval = setInterval(() => {
      setActiveStep((prev) => {
        const nextStep = prev >= 4 ? 1 : prev + 1
        return nextStep
      })
    }, 4000) // 4 seconds per step

    return () => clearInterval(interval)
  }, [isAutoPlaying])

  const handleStepClick = (stepId: number) => {
    setIsAutoPlaying(false)
    setActiveStep(stepId)

    setTimeout(() => {
      setIsAutoPlaying(true)
    }, 10000)
  }

  const faqs = [
    {
      question: "What is custom software development?",
      answer: "Custom software development is the process of creating software solutions specifically tailored to meet the unique needs, workflows, and challenges of a business instead of using off-the-shelf products."
    },
    {
      question: "What types of custom software does Vilva Business build?",
      answer: "Vilva Business builds web applications, mobile apps for iOS and Android, desktop applications, and cloud-based systems designed to scale with your business."
    },
    {
      question: "Why should a business choose custom software over off-the-shelf software?",
      answer: "Custom software offers greater flexibility, tailored functionality, seamless integration, enhanced security, and better scalability compared to off-the-shelf solutions that may not fit specific business needs."
    },
    {
      question: "Can custom software work with my existing systems?",
      answer: "Yes. Custom software can be integrated seamlessly with your existing tools, legacy systems, and third-party APIs to improve workflows and reduce manual work."
    },
    {
      question: "How does custom software benefit business efficiency?",
      answer: "Custom software automates workflows, reduces repetitive tasks, improves data management, and provides real-time insights, leading to higher productivity and efficiency."
    },
    {
      question: "Is custom software scalable for future business growth?",
      answer: "Yes. Custom solutions are built with scalable architecture, allowing you to add new features or expand functionality as your business grows."
    },
    {
      question: "What industries can benefit from custom software development?",
      answer: "Custom software can benefit startups, SMEs, enterprises, fintech firms, healthcare, logistics, ecommerce, and SaaS businesses by addressing their specific industry challenges."
    },
    {
      question: "Does Vilva Business provide ongoing support after delivery?",
      answer: "Yes. Vilva Business offers long-term support, maintenance, bug fixes, updates, and optimization services after the custom software is launched."
    },
    {
      question: "How does custom software development improve security?",
      answer: "Custom solutions allow implementation of robust, business-specific security measures such as encryption, access control, and compliance features, reducing vulnerabilities."
    },
    {
      question: "How long does custom software development typically take?",
      answer: "The timeline varies based on complexity, features, and integrations required. Vilva Business works with you to define clear milestones and delivery schedules tailored to your project goals."
    }
  ];


  const activeStepData = steps.find((step) => step.id === activeStep) || steps[0]

  const [isLoaded, setIsLoaded] = useState(false)
  const [showFloatingTags, setShowFloatingTags] = useState(false)

  useEffect(() => {
    // Trigger initial animation on mount
    const timer = setTimeout(() => {
      setIsLoaded(true)
    }, 100)

    // Show floating tags after device animation
    const floatingTimer = setTimeout(() => {
      setShowFloatingTags(true)
    }, 100) // Increased to ensure main content animates first

    return () => {
      clearTimeout(timer)
      clearTimeout(floatingTimer)
    }
  }, [])

  const floatingTags = [
    { text: "#App Development", position: "-left-[0px] md:top-[50px] top-[30px]", rotation: "rotate-0", delay: "[transition-delay:1000ms]", wave: "animate-wave-1" },
    { text: "#Website Design", position: "md:left-[200px] left-[150px] md:top-[50px] top-[30px]", rotation: "rotate-12", delay: "[transition-delay:1200ms]", wave: "animate-wave-2" },
    { text: "#Admin Panels", position: "-right-16 md:top-[70px] top-[50px]", rotation: "-rotate-8", delay: "[transition-delay:1400ms]", wave: "animate-wave-3" },
    { text: "#Fintech Platforms", position: "-right-[90px] md:bottom-[60px] bottom-[30px]", rotation: "-rotate-8", delay: "[transition-delay:1600ms]", wave: "animate-wave-4" },
    { text: "#SaaS Dashboards", position: "md:-left-[200px] -left-[130px] md:bottom-[140px] bottom-[80px]", rotation: "rotate-8", delay: "[transition-delay:1800ms]", wave: "animate-wave-5" },
  ]

  return (
    <div className="min-h-screen bg-white">

      {/* Hero Section */}
      <section className="relative w-full  overflow-hidden">
        {/* <video
        src="/images/Custom-software/feature/bgvid.mp4"
        autoPlay
        loop
        muted
        playsInline
        className="absolute top-0 left-0 w-full h-full object-cover "
      /> */}
        {/* 
        <div className="relative w-full h-[500px]">
          <div
            className="bg-no-repeat bg-center bg-cover"
            style={{
              backgroundImage: "url('/images/feature/CustomSoftwareBg.png')",
            }}
          />
        </div> */}


        <div
          className="absolute top-0 left-0 w-full h-full opacity-80"
          style={{
            background:
              "#FFF",
          }}
        />

        {/* Removed: this div's only content was a background pointing at
            /images/feature/rectangle.png. That directory does not exist anywhere in the repo, so it
            has been a 404 on every visit to this page while rendering nothing. */}
        <div className="max-w-7xl mx-auto md:mt-[50px] mt-[30px]">
          {/* Main Content */}
          <div className="text-center space-y-[24px] px-[10px]">
            <div>
              <div className="relative">
                <h1 className="lg:text-[50px] md:text-[40px] text-[36px] font-bold z-[30] leading-[120%] text-balance relative">
                  <m.span
                    initial={{ filter: "blur(10px)", opacity: 0, y: 20 }}
                    animate={{ filter: "blur(0px)", opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: 0.1 }}
                    className="text-[#195AFF] inline-block mr-2 font-NeueMontreal"
                  >
                    Trusted
                  </m.span>

                  <m.span
                    initial={{ filter: "blur(10px)", opacity: 0, y: 20 }}
                    animate={{ filter: "blur(0px)", opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    className="text-[#195AFF] inline-block mr-2 font-NeueMontreal"
                  >
                    Custom
                  </m.span>

                  <m.span
                    initial={{ filter: "blur(10px)", opacity: 0, y: 20 }}
                    animate={{ filter: "blur(0px)", opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: 0.3 }}
                    className="text-[#195AFF] inline-block mr-2 font-NeueMontreal"
                  >
                    Software
                  </m.span>

                  <m.span
                    initial={{ filter: "blur(10px)", opacity: 0, y: 20 }}
                    animate={{ filter: "blur(0px)", opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: 0.4 }}
                    className="text-[#061D48] inline-block mr-2 font-NeueMontreal"
                  >
                    for
                  </m.span>

                  <br />

                  <m.span
                    initial={{ filter: "blur(10px)", opacity: 0, y: 20 }}
                    animate={{ filter: "blur(0px)", opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: 0.5 }}
                    className="text-[#061D48] inline-block mr-2 font-NeueMontreal"
                  >
                    Businesses
                  </m.span>
                  <m.span
                    initial={{ filter: "blur(10px)", opacity: 0, y: 20 }}
                    animate={{ filter: "blur(0px)", opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: 0.6 }}
                    className="text-[#061D48] inline-block mr-2 font-NeueMontreal"
                  >
                    Around
                  </m.span>
                  <m.span
                    initial={{ filter: "blur(10px)", opacity: 0, y: 20 }}
                    animate={{ filter: "blur(0px)", opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: 0.7 }}
                    className="text-[#061D48] inline-block font-NeueMontreal"
                  >
                    the World.
                  </m.span>
                </h1>
                <m.div
                  className="absolute top-[42px] right-0 left-[498px] bottom-0 z-[10] md:block hidden"
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.8, delay: 0.8 }}
                >
                  <SvgIcons.CustompageLine />
                </m.div>
              </div>
              <p className={`text-[#374577] font-Schibsted_Grotesk text-[16px] transition-all duration-700 ease-out [transition-delay:800ms] ${showFloatingTags ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"
                }`}>
                Websites, apps, platforms, and tools — <br className=" sm:hidden block" />designed, built, and scaled for your Business.
              </p>
            </div>
            <div className="flex gap-4 justify-center items-center">
              <a href="/book-demo" aria-label="redirect-page">
                <Button className={`bg-[#195AFF] text-white hover:bg-blue-700 md:px-[32px] px-[24px] py-[24px] text-[16px] font-semibold tracking-wider rounded-[8px] transition-all duration-700 ease-out [transition-delay:900ms] ${showFloatingTags ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"
                  }`}>
                  Schedule a Call
                </Button>
              </a>
              {/* <Button className={`bg-white border border-[#195AFF] text-[#195AFF] hover:bg-[#efefef] md:px-[32px] px-[24px] py-[24px] text-[16px] font-medium rounded-[8px] transition-all duration-700 ease-out [transition-delay:1000ms] ${
                  showFloatingTags ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"
                }`}>
              View Works
            </Button> */}
            </div>

            <div className={`transition-all duration-700 ease-out [transition-delay:1100ms] ${showFloatingTags ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"
              }`}>
              <p className="text-[#33C120] text-[12px] font-Schibsted_Grotesk">⚡Get a Response within 24 Hours</p>
            </div>
          </div>

          {/* Animated Device Mockups */}
          <div className="relative pointer-events-none md:max-w-2xl max-w-md mx-auto md:-right-0 -right-[160px]">
            <div className="relative">
              <div
                className={`md:translate-y-32 translate-y-24 transition-all duration-1000 ease-out [transition-delay:1500ms] ${isLoaded
                  ? "md:translate-y-32 translate-y-24 opacity-100"
                  : "translate-y-44 opacity-0"
                  }`}>

                {/* Desktop Image */}
                <Image
                  src={getImageUrl("/vilvabusiness/website/products/custom-software/herobg.webp")}
                  alt="Custom software dashboards and apps built by Vilva Business"
                  width={1200}
                  height={750}
                  className="hidden md:block md:w-[772px] w-auto h-auto object-contain"
                  priority
                />

                {/* Mobile Image */}
                <Image
                  src={getImageUrl("/vilvabusiness/website/products/custom-software/feature/bg-mob.webp")}
                  alt="Custom software apps built by Vilva Business on mobile"
                  width={600}
                  height={700}
                  className="block md:hidden w-full h-auto object-contain"
                  priority
                />
              </div>
              <div className="w-fit absolute md:-left-[70px] -left-[40px] md:bottom-[70px]  bottom-[50px]">
                <div className={`absolute transition-all duration-700 ease-out [transition-delay:1300ms] ${showFloatingTags ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"
                  }`}>
                  <svg xmlns="http://www.w3.org/2000/svg" className="md:w-[38px] w-[24px] md:h-[38px] h-[24px]" viewBox="0 0 39 39" fill="none">
                    <path d="M35.1182 27.014L30.2391 15.6033C29.3505 13.5145 28.0255 12.3298 26.5135 12.2519C25.017 12.1739 23.5673 13.2183 22.4605 15.2136L19.4988 20.5293C18.8753 21.6516 17.9867 22.3219 17.0203 22.3999C16.0381 22.4934 15.0561 21.979 14.2611 20.9657L13.9181 20.5293C12.8114 19.1419 11.4396 18.4716 10.0367 18.6119C8.63374 18.7522 7.43344 19.7187 6.63844 21.2931L3.94168 26.671C2.97521 28.6196 3.06874 30.8799 4.20668 32.7193C5.34462 34.5587 7.32432 35.6654 9.49109 35.6654H29.3817C31.4705 35.6654 33.4191 34.621 34.5726 32.8752C35.7573 31.1293 35.9444 28.9313 35.1182 27.014Z" fill="#BC7BA5" />
                    <path d="M11.6594 13.8587C14.5694 13.8587 16.9282 11.4998 16.9282 8.58987C16.9282 5.67998 14.5694 3.32104 11.6594 3.32104C8.74956 3.32104 6.39062 5.67998 6.39062 8.58987C6.39062 11.4998 8.74956 13.8587 11.6594 13.8587Z" fill="#BC7BA5" />
                  </svg>
                </div>
              </div>
              <div className="w-fit absolute md:left-[70px] left-[40px] md:top-[110px] top-[90px]">
                <div className={`absolute transition-all duration-700 ease-out [transition-delay:1400ms] ${showFloatingTags ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"
                  }`}>
                  <div className="bg-[#DFF195] md:p-[8px] p-[4px] rounded-full">
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-[18px] md:w-[24px] h-[18px] md:h-[24px]" viewBox="0 0 17 17" fill="none">
                      <g clipPath="url(#clip0_917_97)">
                        <path d="M5.76133 1.67864C5.52284 5.7478 5.00283 6.41519 1.11555 7.64146C5.18471 7.87995 5.8521 8.39993 7.07836 12.2872C7.31686 8.21809 7.83684 7.5507 11.7241 6.32443C7.65499 6.08593 6.98757 5.56596 5.76133 1.67864Z" fill="#7C9221" />
                        <path d="M12.4456 8.42691C12.294 11.0147 11.9632 11.4392 9.49106 12.219C12.0788 12.3707 12.5034 12.7014 13.2832 15.1736C13.4348 12.5858 13.7656 12.1613 16.2377 11.3815C13.6499 11.2298 13.2254 10.8991 12.4456 8.42691Z" fill="#7C9221" />
                      </g>
                      <defs>
                        <clipPath id="clip0_917_97">
                          <rect width="14.5454" height="14.5455" fill="white" transform="translate(0.443359 2.22461) rotate(-7.07692)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                </div>
              </div>
              <div className="w-fit absolute md:right-[230px] right-[140px] top-[50px]">
                <div className={`absolute transition-all duration-700 ease-out [transition-delay:1500ms] ${showFloatingTags ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"
                  }`}>
                  <div className="[background:radial-gradient(360.25%_138.62%_at_5.57%_2.63%,_#98CBFF_0%,_#7088FF_100%)] [box-shadow:inset_0_0_10px_rgba(25,90,255,0.1)] md:p-[20px] p-[10px] rounded-full">
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-[18px] md:w-[22px] h-[18px] md:h-[22px]" viewBox="0 0 27 27" fill="none">
                      <g clipPath="url(#clip0_917_54)">
                        <path d="M12.7157 1.93583C6.11154 2.49052 1.20748 8.29391 1.76217 14.8981C2.31686 21.5022 8.12026 26.4063 14.7244 25.8516C21.3285 25.2969 26.2326 19.4935 25.6779 12.8893C25.1165 6.28873 19.3175 1.38843 12.7157 1.93583ZM18.788 13.8517C18.7191 14.0247 18.5959 14.1707 18.4367 14.2674L18.4371 14.2717L11.891 18.2621C11.4867 18.5084 10.9593 18.3804 10.713 17.9761C10.643 17.8612 10.601 17.7314 10.5904 17.5972L10.0165 10.7642C9.97671 10.2924 10.3268 9.87776 10.7985 9.83789C10.9312 9.8267 11.0646 9.84654 11.1883 9.89587L18.3083 12.7385C18.7482 12.9134 18.963 13.4119 18.788 13.8517Z" fill="#F1FAFF" />
                      </g>
                      <defs>
                        <clipPath id="clip0_917_54">
                          <rect width="24" height="24" fill="white" transform="translate(0.757812 2.94019) rotate(-4.80109)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                </div>
              </div>
              <div className="w-fit absolute right-[0px] md:bottom-[190px] bottom-[130px]">
                <div className={`absolute transition-all duration-700 ease-out [transition-delay:1600ms] ${showFloatingTags ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"
                  }`}>
                  <div className="bg-[#9EF8B2] py-[6px] px-[12px] rounded-[4px]">
                    <p className="text-[#00911F] text-[10px]">button</p>
                  </div>
                </div>
              </div>
              <div className="w-fit absolute md:right-[100px] right-[70px] md:bottom-[190px] bottom-[120px]">
                <div className={`absolute transition-all duration-700 ease-out [transition-delay:1700ms] ${showFloatingTags ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"
                  }`}>
                  <div className="bg-[#7486EE] md:w-[40px] w-[30px] md:h-[40px] h-[30px] flex justify-center items-center rounded-[40%]">
                    <p className="text-white text-[12px]">T</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Animated Floating Tags */}
            <div className="pointer-events-none">
              {floatingTags.map((tag, index) => (
                <div
                  key={index}
                  className={`absolute ${tag.position} transition-all duration-700 ease-out ${tag.delay} ${tag.wave} ${showFloatingTags ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"
                    }`}
                  style={{
                    animationDelay: `${(index + 5) * 200}ms`, // Starting after main content
                  }}
                >
                  <div className={`px-[20px] py-[12px] font-Sanchez_Regular font-medium transform ${tag.rotation} hover:scale-105 transition-transform duration-300 ${tag.text.includes("Website Design") || tag.text.includes("App Development")
                    ? "text-[#5477B5]"
                    : "text-[#5477B5]"
                    } rounded-[20px] md:text-[14px] text-[10px] bg-[linear-gradient(134deg,#FFF_32.27%,#DCE5FF_73.41%)] shadow-[-24px_146px_42px_0_rgba(116,177,216,0),-15px_94px_38px_0_rgba(116,177,216,0.01),-9px_53px_32px_0_rgba(116,177,216,0.05),-4px_23px_24px_0_rgba(116,177,216,0.09),-1px_6px_13px_0_rgba(116,177,216,0.10)]`}
                  >
                    {tag.text}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Custom CSS for wave animations */}
        <style jsx>{`
        @keyframes wave-1 {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-10px) rotate(0deg); }
        }
        @keyframes wave-2 {
          0%, 100% { transform: translateY(0px) rotate(12deg); }
          50% { transform: translateY(-8px) rotate(12deg); }
        }
        @keyframes wave-3 {
          0%, 100% { transform: translateY(0px) rotate(-8deg); }
          50% { transform: translateY(-12px) rotate(-8deg); }
        }
        @keyframes wave-4 {
          0%, 100% { transform: translateY(0px) rotate(-8deg); }
          50% { transform: translateY(-6px) rotate(-8deg); }
        }
        @keyframes wave-5 {
          0%, 100% { transform: translateY(0px) rotate(8deg); }
          50% { transform: translateY(-9px) rotate(8deg); }
        }
        
        .animate-wave-1 { animation: wave-1 3s ease-in-out infinite; }
        .animate-wave-2 { animation: wave-2 2.5s ease-in-out infinite 0.5s; }
        .animate-wave-3 { animation: wave-3 3.5s ease-in-out infinite 1s; }
        .animate-wave-4 { animation: wave-4 2.8s ease-in-out infinite 1.5s; }
        .animate-wave-5 { animation: wave-5 3.2s ease-in-out infinite 2s; }
      `}</style>
      </section>

      <TrustedPartners />


      {/* Interactive Build Section */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-[40px] mb-[16px] sm:text-4xl lg:text-[48px] font-bold font-NeueMontreal text-gray-900">
              What Can <span className="text-[#195AFF] font-NeueMontreal">We Build</span> for You?
            </h2>
            <p className="text-[18px] text-[#374577] mx-auto font-Schibsted_Grotesk">
              Web, mobile, desktop, or cloud — we design and develop core systems that fuel modern, scalable businesses.
            </p>
          </div>

          <div className="flex md:h-[600px]  gap-8 ">
            {/* Left Side - Numbered Steps */}
            <div className="w-1/12 md:block hidden">
              {steps.map((step) => (
                <m.div
                  key={step.id}
                  className="cursor-pointer"
                  onClick={() => handleStepClick(step.id)}
                >
                  <div className="flex flex-col items-center">
                    <m.div
                      className="w-0.5 h-[80px] mb-2 transition-colors duration-500"
                      animate={{
                        backgroundColor: step.id <= activeStep ? "#195AFF" : "#d1d5db",
                      }}
                    />
                    <m.div
                      className="text-2xl font-bold text-[18px] transition-colors duration-500"
                      animate={{
                        color: step.id <= activeStep ? "#2563eb" : "#090D28",
                      }}
                    >
                      {String(step.id).padStart(2, "0")}
                    </m.div>
                  </div>
                </m.div>
              ))}
            </div>

            <div className="w-full flex flex-col md:flex-row rounded-[24px] border border-[#EDF5FE] bg-gradient-to-b from-[#F6FCFF] to-[#F5F6FE]">
              {/* Center - Dynamic Mockup */}
              <div className="md:w-1/2 w-full flex justify-center rounded-[24px] p-[20px]">
                <div className="">
                  <AnimatePresence mode="wait">
                    <m.div
                      key={activeStep}
                      initial={{ opacity: 0, scale: 0.9, y: 20 }}
                      animate={{ opacity: 1, scale: 1, y: 0 }}
                      exit={{ opacity: 0, scale: 0.9, y: -20 }}
                      transition={{ duration: 0.5, ease: "easeInOut" }}
                      className="relative  w-full"
                    >
                      {/* Mobile Mockup - Step 1 */}
                      {activeStepData.mockup.type === "mobile" && (
                        <div className="">
                          {/* <div className="w-full h-full bg-white rounded-[2.5rem] relative overflow-hidden">
                          <div className="flex justify-between items-center px-6 py-3 text-[#090D28] text-sm font-medium">
                            <span>9:41</span>
                            <div className="flex items-center space-x-1">
                              <div className="flex space-x-1">
                                {[1, 2, 3, 4].map((i) => (
                                  <div key={i} className="w-1 h-1 bg-black rounded-full"></div>
                                ))}
                              </div>
                              <div className="w-6 h-3 border border-black rounded-sm">
                                <div className="w-4 h-2 bg-black rounded-sm m-0.5"></div>
                              </div>
                            </div>
                          </div>

                          <div className="absolute top-16 right-6">
                            <span className="text-[#195AFF] text-sm font-medium">Skip</span>
                          </div>

                          <div className="px-6 pt-8 text-center">
                            <h3 className="text-2xl font-bold text-gray-900 mb-4">{activeStepData.mockup.content.title}</h3>
                            <p className="text-[#374577] text-sm mb-8 leading-relaxed">
                              {activeStepData.mockup.content.subtitle}
                            </p>

                            <div className="inline-block mb-4">
                              <span className="px-3 py-1 bg-gray-100 text-[#374577] rounded-full text-xs font-medium uppercase tracking-wide">
                                POPULAR
                              </span>
                            </div>

                            <div className="mb-6">
                              <h4 className="text-lg font-semibold text-gray-900 mb-2">
                                {activeStepData.mockup.content.category}
                              </h4>
                            </div>

                            <div className="text-4xl font-bold text-gray-400 mb-8">
                              {activeStepData.mockup.content.price}
                            </div>
                          </div>
                        </div> */}
                          {/* <Image src={img1} alt="image tag" /> */}
                          <Image
                            src={getImageUrl("/vilvabusiness/website/products/custom-software/feature/img1.webp")}
                            alt="Vilva custom core software solutions mockup"
                            width={800}
                            height={500}
                            className="hidden md:block w-full h-auto object-contain"
                            loading="lazy"
                            decoding="async"
                          />

                          <Image

                            src={getImageUrl("/vilvabusiness/website/products/custom-software/img1-mob.webp")}
                            alt="Vilva custom core software solutions on mobile"
                            width={800}
                            height={500}
                            className="block md:hidden w-full h-auto object-contain"
                            loading="lazy"
                            decoding="async"
                          />
                        </div>
                      )}

                      {/* Cards Mockup - Step 2 */}
                      {activeStepData.mockup.type === "cards" && (
                        <div className="relative">
                          {/* {activeStepData.mockup.content.cards.map((card, idx) => (
                          <m.div
                            key={idx}
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: idx * 0.1 }}
                            className={`absolute bg-blue-100 rounded-2xl p-4 shadow-lg ${
                              idx === 0
                                ? "top-0 left-8 w-64 h-20"
                                : idx === 1
                                  ? "top-16 left-0 w-72 h-24"
                                  : idx === 2
                                    ? "top-32 left-12 w-60 h-20"
                                    : idx === 3
                                      ? "top-48 left-4 w-68 h-22"
                                      : "top-64 left-0 w-80 h-28"
                            }`}
                          >
                            <h4 className="font-bold text-blue-900 text-lg mb-1">{card.title}</h4>
                            <p className="text-blue-700 text-xs leading-tight">{card.subtitle}</p>
                            {idx === 2 && (
                              <div className="absolute -right-4 -bottom-2 w-8 h-8 bg-[#195AFF] rounded flex items-center justify-center">
                                <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 24 24">
                                  <path d="M7 4V2C7 1.45 7.45 1 8 1H16C16.55 1 17 1.45 17 2V4H20C20.55 4 21 4.45 21 5S20.55 6 20 6H19V19C19 20.1 18.1 21 17 21H7C5.9 21 5 20.1 5 19V6H4C3.45 6 3 5.55 3 5S3.45 4 4 4H7Z" />
                                </svg>
                              </div>
                            )}
                          </m.div>
                        ))} */}
                          <Image
                            src={getImageUrl("/vilvabusiness/website/products/custom-software/feature/img2.webp")}
                            alt="Industry-specific custom software for EdTech, healthcare, e-commerce and fintech"
                            width={800}
                            height={500}
                            className="hidden md:block w-full h-auto object-contain"
                            loading="lazy"
                            decoding="async"
                          />
                          <Image
                            src={getImageUrl("/vilvabusiness/website/products/custom-software/img2-mob.webp")}
                            alt="Industry-specific custom software on mobile"
                            width={768}
                            height={900}
                            className="block md:hidden w-full h-auto object-contain"
                            loading="lazy"
                            decoding="async"
                          />
                        </div>
                      )}

                      {/* Desktop Mockup - Step 3 */}
                      {activeStepData.mockup.type === "desktop" && (
                        <div className=" ">
                          {/* <div className="w-full h-full bg-white rounded-t-lg flex">
                          <div className="w-1/3 bg-gray-50 p-4 border-r">
                            <div className="flex items-center space-x-2 mb-4">
                              <div className="w-2 h-2 bg-[#195AFF] rounded-full"></div>
                              <span className="text-sm font-medium text-gray-900">
                                {activeStepData.mockup.content.title}
                              </span>
                            </div>
                            <div className="space-y-1">
                              {activeStepData.mockup.content.sections.slice(0, 8).map((section, idx) => (
                                <div key={idx} className="text-xs text-[#374577] py-1 px-2 hover:bg-gray-100 rounded">
                                  {section}
                                </div>
                              ))}
                            </div>
                          </div>
                          <div className="flex-1 p-4 bg-blue-50">
                            <div className="space-y-2">
                              <div className="h-3 bg-blue-200 rounded w-3/4"></div>
                              <div className="h-3 bg-blue-200 rounded w-1/2"></div>
                              <div className="h-3 bg-blue-200 rounded w-2/3"></div>
                            </div>
                          </div>
                        </div>
                        <div className="h-4 bg-gray-800 rounded-b-xl relative">
                          <div className="absolute left-1/2 -translate-x-1/2 top-1 w-8 h-2 bg-[#374577] rounded-full"></div>
                        </div> */}
                          <Image
                            src={getImageUrl("/vilvabusiness/website/products/custom-software/feature/img3.webp")}
                            alt="Specialized custom software admin dashboard"
                            width={800}
                            height={500}
                            className="md:w-[772px] w-auto md:h-full object-contain"
                            loading="lazy"
                            decoding="async"
                          />
                        </div>
                      )}

                      {/* Chat Mockup - Step 4 */}
                      {activeStepData.mockup.type === "chat" && (
                        <div className="">
                          {/* <div className="w-full h-full bg-gradient-to-b from-blue-100 to-blue-200 rounded-[2.5rem] relative overflow-hidden">
                          <div className="absolute top-8 left-1/2 -translate-x-1/2 bg-blue-200 px-4 py-2 rounded-full">
                            <span className="text-blue-800 text-sm font-medium">{activeStepData.mockup.content.title}</span>
                          </div>

                          <div className="px-6 pt-20 space-y-4">
                            {activeStepData.mockup.content.messages.map((message, idx) => (
                              <m.div
                                key={idx}
                                initial={{ opacity: 0, y: 10 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: idx * 0.2 }}
                                className={`flex ${message.sender === "user" ? "justify-end" : "justify-start"}`}
                              >
                                <div
                                  className={`max-w-xs px-4 py-2 rounded-2xl ${
                                    message.sender === "user" ? "bg-[#195AFF] text-white" : "bg-white text-gray-900"
                                  }`}
                                >
                                  <p className="text-sm">{message.text}</p>
                                </div>
                              </m.div>
                            ))}
                          </div>

                          <div className="absolute bottom-20 left-1/2 -translate-x-1/2">
                            <div className="w-16 h-16 bg-black rounded-full flex items-center justify-center">
                              <div className="w-3 h-3 bg-white rounded-full"></div>
                              <div className="w-3 h-3 bg-white rounded-full ml-1"></div>
                            </div>
                          </div>
                        </div> */}
                          <Image
                            src={getImageUrl("/vilvabusiness/website/products/custom-software/feature/img4.webp")}
                            alt="Future-tech custom software chat and AI integration"
                            width={800}
                            height={500}
                            className="md:w-[772px] w-auto md:h-full object-contain"
                            loading="lazy"
                            decoding="async"
                          />
                        </div>
                      )}
                    </m.div>
                  </AnimatePresence>
                </div>
              </div>

              {/* Right Side - Solutions Panel */}
              <div className="md:w-1/2 w-full ">
                <div className=" rounded-2xl h-full border-gray-100 md:p-6 p-4">
                  {steps.map((step) => (
                    <m.div key={step.id} className={`p-[16px] border-b pb-[12px] border-[#DFECF9] ${activeStep === step.id
                      ? "rounded-[8px]  border border-[#D8E9FD] bg-white"
                      : ""
                      }`}
                      style={{
                        boxShadow: activeStep === step.id
                          ? "-1px -1px 4px 0 rgba(13, 124, 189, 0.25), 0 1px 6px 0 rgba(32, 62, 255, 0.15)"
                          : "none", // or another default shadow
                      }}

                      initial={false}>
                      <m.div
                        className="flex items-center justify-between cursor-pointer "
                        onClick={() => handleStepClick(step.id)}
                        whileHover={{ scale: 1.02 }}
                        whileTap={{ scale: 0.98 }}
                      >
                        <div className="flex items-center space-x-3">
                          {/* <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                            <svg className="w-4 h-4 text-[#195AFF]" fill="currentColor" viewBox="0 0 24 24">
                              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                            </svg>
                          </div> */}
                          <div className="rounded-[4px] border-[0.6px] border-[#D8E9FD] bg-[linear-gradient(180deg,#FFF_48.42%,#D8E9FD_100%)] p-2">
                            {step.icon}
                          </div>
                          <h3
                            className={`lg:text-[18px] font-Schibsted_Grotesk md:text-[14px] text-[14px] font-bold transition-colors duration-300 ${activeStep === step.id ? "text-[#090D28]" : "text-[#090D28]"
                              }`}
                          >
                            {step.title}
                          </h3>
                        </div>
                        <m.button
                          className="text-gray-400 hover:text-[#374577]"
                          aria-label={activeStep === step.id ? "Collapse step" : "Expand step"}
                          animate={{ rotate: activeStep === step.id ? 0 : 0 }}
                        >
                          <svg
                            className="w-5 h-5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            aria-hidden="true"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d={activeStep === step.id ? "M20 20H4" : "M12 6v6m0 0v6m0-6h6m-6 0H6"}
                            />
                          </svg>
                        </m.button>
                      </m.div>

                      <AnimatePresence>
                        {activeStep === step.id && (
                          <m.div
                            initial={{ opacity: 0, height: 0 }}
                            animate={{ opacity: 1, height: "auto" }}
                            exit={{ opacity: 0, height: 0 }}
                            transition={{ duration: 0.3 }}
                            className="overflow-hidden font-Schibsted_Grotesk "
                          >
                            <div className="space-y-3 text-sm text-[#434552] font-Schibsted_Grotesk mt-4">
                              {step.content.map((item, idx) => (
                                <m.div
                                  key={idx}
                                  initial={{ opacity: 0, x: -10 }}
                                  animate={{ opacity: 1, x: 0 }}
                                  transition={{ delay: idx * 0.05 }}
                                  className="font-Schibsted_Grotesk"
                                >
                                  {item}
                                </m.div>
                              ))}
                            </div>
                          </m.div>
                        )}
                      </AnimatePresence>
                    </m.div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>



      {/* Comparison Table */}
      <section className="py-20 bg-white !bg-cover !bg-center !bg-no-repeat w-full"
        style={{ backgroundImage: `url($getImageUrl("/vilvabusiness/website/products/custom-software/feature/bg.webp")})` }}>
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 space-y-[30px]">

          <div className="bg-[#D7E0EB] rounded-[8px] p-[4px] w-fit mx-auto">
            <div className="flex items-center w-fit bg-white  rounded-[8px]">
              <div className="flex relative">
                <input type="text" className="bg-white p-2 border-0 rounded-[8px] !text-[16px] !font-medium font-Schibsted_Grotesk placeholder:!text-gray-400" placeholder="Why Choose Vilva?" />
                {/* <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-search-icon lucide-search absolute inset"><path d="m21 21-4.34-4.34" /><circle cx="11" cy="11" r="8" /></svg> */}
              </div>
              <div className=" px-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-search-icon lucide-search text-gray-400"><path d="m21 21-4.34-4.34" /><circle cx="11" cy="11" r="8" /></svg>
              </div>
            </div>
          </div>

          <div className="text-center ">
            <h2 className="text-[#090D28] md:text-[32px] text-[20px] font-bold font-NeueMontreal">
              The Smart Alternative to Agencies & Freelancers
            </h2>
          </div>

          <div className=" overflow-hidden">
            <div className="overflow-x-auto ">
              {/* <div className="bg-red-300 max-w-7xl mx-auto p-4"> */}
              <table className="max-w-7xl mx-auto bg-white rounded-[16px] p-[8px] ">
                <thead className="border-b">
                  <tr>
                    <th className="md:px-6 px-[12px] md:py-[16px] py-[12px] text-left md:text-[18px] text-[14px] font-NeueMontreal font-medium text-[#000000]">Features</th>
                    <th className="md:px-6 px-[12px] md:py-[16px] py-[12px] text-center md:text-[18px] text-[14px] font-NeueMontreal font-medium text-[#195AFF]">Vilva Logo</th>
                    <th className="md:px-6 px-[12px] md:py-[16px] py-[12px] text-center md:text-[18px] text-[14px] font-NeueMontreal font-medium text-[#000000]">Big Agencies</th>
                    <th className="md:px-6 px-[12px] md:py-[16px] py-[12px] text-center md:text-[18px] text-[14px] font-NeueMontreal font-medium text-[#000000]">Freelancers</th>
                  </tr>
                </thead>
                <tbody className="divide-y">
                  <tr>
                    <td className="md:px-6 px-[12px] md:py-[16px] py-[12px] text-sm font-medium text-[#000000]">
                      <div className="">
                        <p className="text-[#3D3D3D] text-[16px] font-Schibsted_Grotesk">Cost</p>
                      </div>
                    </td>
                    <td className="md:px-6 px-[12px] md:py-[16px] py-[12px] text-center">
                      <div className="flex justify-center">
                        <div className="p-[4px] bg-[#35C446] rounded-[4px] flex items-center justify-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M3 7.8632L5.81429 10.6775C5.91329 10.7777 6.03118 10.8573 6.16115 10.9116C6.29112 10.9659 6.43057 10.9939 6.57143 10.9939C6.71233 10.9939 6.85173 10.9659 6.98173 10.9116C7.11167 10.8573 7.22953 10.7777 7.3286 10.6775L13 5.0061" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </div>
                      </div>
                    </td>
                    <td className="md:px-6 px-[12px] md:py-[16px] py-[12px] text-center">
                      <div className="flex justify-center">
                        <div className="p-[4px] bg-[#ED4848] rounded-[4px] flex items-center justify-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M12.6673 3.33331L3.33398 12.6666" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M12.6673 12.6666L3.33398 3.33331" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </div>
                      </div>
                    </td>
                    <td className="md:px-6 px-[12px] md:py-[16px] py-[12px] text-center">
                      <div className="flex justify-center">
                        <div className="p-[4px] bg-[#35C446] rounded-[4px] flex items-center justify-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M3 7.8632L5.81429 10.6775C5.91329 10.7777 6.03118 10.8573 6.16115 10.9116C6.29112 10.9659 6.43057 10.9939 6.57143 10.9939C6.71233 10.9939 6.85173 10.9659 6.98173 10.9116C7.11167 10.8573 7.22953 10.7777 7.3286 10.6775L13 5.0061" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr className="bg-[#F5F6F8]">
                    <td className="md:px-6 px-[12px] md:py-[16px] py-[12px] text-sm font-medium text-gray-900">
                      <div className="">
                        <p className="text-[#3D3D3D] text-[16px] font-Schibsted_Grotesk">Delivery Speed</p>
                      </div>
                    </td>
                    <td className="md:px-6 px-[12px] md:py-[16px] py-[12px] text-center">
                      <div className="flex justify-center">
                        <div className="p-[4px] bg-[#35C446] rounded-[4px] flex items-center justify-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M3 7.8632L5.81429 10.6775C5.91329 10.7777 6.03118 10.8573 6.16115 10.9116C6.29112 10.9659 6.43057 10.9939 6.57143 10.9939C6.71233 10.9939 6.85173 10.9659 6.98173 10.9116C7.11167 10.8573 7.22953 10.7777 7.3286 10.6775L13 5.0061" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </div>
                      </div>
                    </td>
                    <td className="md:px-6 px-[12px] md:py-[16px] py-[12px] text-center">
                      <div className="flex justify-center">
                        <div className="p-[4px] bg-[#ED4848] rounded-[4px] flex items-center justify-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M12.6673 3.33331L3.33398 12.6666" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M12.6673 12.6666L3.33398 3.33331" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </div>
                      </div>
                    </td>
                    <td className="md:px-6 px-[12px] md:py-[16px] py-[12px] text-center">
                      <div className="flex justify-center">
                        <div className="p-[4px] bg-[#ED4848] rounded-[4px] flex items-center justify-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M12.6673 3.33331L3.33398 12.6666" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M12.6673 12.6666L3.33398 3.33331" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="md:px-6 px-[12px] md:py-[16px] py-[12px] text-sm font-medium text-gray-900">
                      <div className="">
                        <p className="text-[#3D3D3D] text-[16px] font-Schibsted_Grotesk">Quality</p>
                      </div>
                    </td>
                    <td className="md:px-6 px-[12px] md:py-[16px] py-[12px] text-center">
                      <div className="flex justify-center">
                        <div className="p-[4px] bg-[#35C446] rounded-[4px] flex items-center justify-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M3 7.8632L5.81429 10.6775C5.91329 10.7777 6.03118 10.8573 6.16115 10.9116C6.29112 10.9659 6.43057 10.9939 6.57143 10.9939C6.71233 10.9939 6.85173 10.9659 6.98173 10.9116C7.11167 10.8573 7.22953 10.7777 7.3286 10.6775L13 5.0061" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </div>
                      </div>
                    </td>
                    <td className="md:px-6 px-[12px] md:py-[16px] py-[12px] text-center">
                      <div className="flex justify-center">
                        <div className="p-[4px] bg-[#35C446] rounded-[4px] flex items-center justify-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M3 7.8632L5.81429 10.6775C5.91329 10.7777 6.03118 10.8573 6.16115 10.9116C6.29112 10.9659 6.43057 10.9939 6.57143 10.9939C6.71233 10.9939 6.85173 10.9659 6.98173 10.9116C7.11167 10.8573 7.22953 10.7777 7.3286 10.6775L13 5.0061" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </div>
                      </div>
                    </td>
                    <td className="md:px-6 px-[12px] md:py-[16px] py-[12px] text-center">
                      <div className="flex justify-center">
                        <div className="p-[4px] bg-[#ED4848] rounded-[4px] flex items-center justify-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M12.6673 3.33331L3.33398 12.6666" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M12.6673 12.6666L3.33398 3.33331" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr className="bg-[#F5F6F8]">
                    <td className="md:px-6 px-[12px] md:py-[16px] py-[12px] text-sm font-medium text-gray-900">
                      <div className="">
                        <p className="text-[#3D3D3D] text-[16px] font-Schibsted_Grotesk">Support</p>
                      </div>
                    </td>
                    <td className="md:px-6 px-[12px] md:py-[16px] py-[12px] text-center">
                      <div className="flex justify-center">
                        <div className="p-[4px] bg-[#35C446] rounded-[4px] flex items-center justify-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M3 7.8632L5.81429 10.6775C5.91329 10.7777 6.03118 10.8573 6.16115 10.9116C6.29112 10.9659 6.43057 10.9939 6.57143 10.9939C6.71233 10.9939 6.85173 10.9659 6.98173 10.9116C7.11167 10.8573 7.22953 10.7777 7.3286 10.6775L13 5.0061" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </div>
                      </div>
                    </td>
                    <td className="md:px-6 px-[12px] md:py-[16px] py-[12px] text-center">
                      <div className="flex justify-center">
                        <div className="p-[4px] bg-[#35C446] rounded-[4px] flex items-center justify-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M3 7.8632L5.81429 10.6775C5.91329 10.7777 6.03118 10.8573 6.16115 10.9116C6.29112 10.9659 6.43057 10.9939 6.57143 10.9939C6.71233 10.9939 6.85173 10.9659 6.98173 10.9116C7.11167 10.8573 7.22953 10.7777 7.3286 10.6775L13 5.0061" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </div>
                      </div>
                    </td>
                    <td className="md:px-6 px-[12px] md:py-[16px] py-[12px] text-center">
                      <div className="flex justify-center">
                        <div className="p-[4px] bg-[#ED4848] rounded-[4px] flex items-center justify-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M12.6673 3.33331L3.33398 12.6666" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M12.6673 12.6666L3.33398 3.33331" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="md:px-6 px-[12px] md:py-[16px] py-[12px] text-sm font-medium text-gray-900">
                      <div className="">
                        <p className="text-[#3D3D3D] text-[16px] font-Schibsted_Grotesk">Flexibility & Communication</p>
                      </div>
                    </td>
                    <td className="md:px-6 px-[12px] md:py-[16px] py-[12px] text-center">
                      <div className="flex justify-center">
                        <div className="p-[4px] bg-[#35C446] rounded-[4px] flex items-center justify-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M3 7.8632L5.81429 10.6775C5.91329 10.7777 6.03118 10.8573 6.16115 10.9116C6.29112 10.9659 6.43057 10.9939 6.57143 10.9939C6.71233 10.9939 6.85173 10.9659 6.98173 10.9116C7.11167 10.8573 7.22953 10.7777 7.3286 10.6775L13 5.0061" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </div>
                      </div>
                    </td>
                    <td className="md:px-6 px-[12px] md:py-[16px] py-[12px] text-center">
                      <div className="flex justify-center">
                        <div className="p-[4px] bg-[#ED4848] rounded-[4px] flex items-center justify-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M12.6673 3.33331L3.33398 12.6666" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M12.6673 12.6666L3.33398 3.33331" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </div>
                      </div>
                    </td>
                    <td className="md:px-6 px-[12px] md:py-[16px] py-[12px] text-center">
                      <div className="flex justify-center">
                        <div className="p-[4px] bg-[#35C446] rounded-[4px] flex items-center justify-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M3 7.8632L5.81429 10.6775C5.91329 10.7777 6.03118 10.8573 6.16115 10.9116C6.29112 10.9659 6.43057 10.9939 6.57143 10.9939C6.71233 10.9939 6.85173 10.9659 6.98173 10.9116C7.11167 10.8573 7.22953 10.7777 7.3286 10.6775L13 5.0061" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              {/* </div> */}
            </div>
          </div>

          <div className=" md:my-[50px] my-[20px] h-[1px] w-[100%] bg-[linear-gradient(90deg,rgba(218,227,246,0)_0.83%,#C9DBE1_50%,rgba(201,219,225,0)_99.17%)]">
            {/* Your content */}
          </div>

          <div className="grid md:grid-cols-4 gap-6 md:p-[0px] p-[40px]">
            <div className="bg-white p-[20px] rounded-[16px]  shadow-md">
              <div className="flex flex-col space-y-[8px]">
                <div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <path d="M35.1001 22.073C35.018 22.0729 34.9367 22.0891 34.8609 22.1205C34.785 22.1519 34.7161 22.1979 34.6581 22.2559C34.6 22.314 34.554 22.3829 34.5226 22.4588C34.4912 22.5346 34.4751 22.6159 34.4751 22.698V27.9787C34.475 28.1445 34.4091 28.3034 34.2919 28.4206C34.1747 28.5377 34.0158 28.6036 33.8501 28.6037H4.375C4.20927 28.6036 4.05037 28.5377 3.93318 28.4206C3.81599 28.3034 3.75011 28.1445 3.75 27.9787V9.1665C3.75011 9.00078 3.816 8.84187 3.93318 8.72469C4.05037 8.6075 4.20927 8.54162 4.375 8.5415H17.4561C17.6218 8.5415 17.7808 8.47566 17.898 8.35845C18.0152 8.24124 18.0811 8.08226 18.0811 7.9165C18.0811 7.75074 18.0152 7.59177 17.898 7.47456C17.7808 7.35735 17.6218 7.2915 17.4561 7.2915H4.375C3.87789 7.29205 3.40129 7.48976 3.04977 7.84128C2.69826 8.19279 2.50054 8.66939 2.5 9.1665V27.9787C2.50054 28.4759 2.69826 28.9525 3.04977 29.304C3.40129 29.6555 3.87789 29.8532 4.375 29.8537H16.4886V31.7678C16.4872 32.2708 16.4219 32.7715 16.2946 33.2581C9.60724 33.6583 7.19135 35.4011 7.08008 35.4848C6.95233 35.5856 6.86892 35.7323 6.84756 35.8936C6.8262 36.0549 6.86858 36.2182 6.9657 36.3487C7.06281 36.4793 7.207 36.5668 7.36764 36.5928C7.52828 36.6187 7.6927 36.581 7.82597 36.4876C7.85461 36.4669 10.7611 34.4241 19.1119 34.4241C28.0453 34.4671 29.9769 36.4669 30.7684 36.6098C30.8984 36.6073 31.0244 36.5647 31.1292 36.4877C31.234 36.4107 31.3123 36.3032 31.3534 36.1799C31.3946 36.0565 31.3965 35.9235 31.359 35.799C31.3214 35.6746 31.2462 35.5648 31.1438 35.4848C31.0325 35.4011 28.6165 33.6582 21.9287 33.2581C21.7332 32.1346 21.6682 30.9922 21.7352 29.8537H33.8501C34.3472 29.8532 34.8238 29.6555 35.1753 29.304C35.5268 28.9524 35.7246 28.4758 35.7251 27.9787V22.698C35.7251 22.6159 35.709 22.5346 35.6776 22.4588C35.6462 22.3829 35.6002 22.314 35.5421 22.2559C35.4841 22.1979 35.4152 22.1519 35.3393 22.1205C35.2635 22.0891 35.1822 22.0729 35.1001 22.073ZM17.5877 33.1979C17.6858 32.7275 17.7364 32.2484 17.7386 31.7678V29.8537H20.4852C20.4316 30.9707 20.4821 32.0903 20.636 33.1979C19.6706 33.1666 18.5532 33.1666 17.5877 33.1979Z" fill="url(#paint0_linear_917_767)" />
                    <path d="M36.2688 11.4004C36.251 11.3996 36.2339 11.3937 36.2194 11.3833C36.205 11.3729 36.194 11.3584 36.1876 11.3418C35.9826 10.2519 35.4392 9.51023 35.1462 8.68806C35.3642 8.43058 35.4771 8.10035 35.4623 7.7633C35.4475 7.42626 35.3061 7.10719 35.0664 6.86979L34.0166 5.81996C33.7794 5.57943 33.4601 5.4375 33.1226 5.42267C32.7851 5.40784 32.4545 5.5212 32.1972 5.74001C31.3484 5.30915 30.4603 4.96052 29.5451 4.69886C29.528 4.69223 29.5132 4.68069 29.5026 4.66569C29.4919 4.65069 29.4859 4.63289 29.4854 4.61452C29.4573 4.27843 29.3035 3.96528 29.0547 3.73755C28.8059 3.50982 28.4805 3.38425 28.1432 3.38588H26.6588C26.3253 3.38415 26.0031 3.50694 25.7553 3.73022C25.5075 3.95351 25.352 4.26121 25.3191 4.59313C25.3197 4.63731 25.2972 4.68957 25.2575 4.69813C24.3568 4.91493 23.4956 5.2712 22.705 5.75404C22.6887 5.76235 22.6703 5.7654 22.6523 5.76277C22.6342 5.76015 22.6175 5.75197 22.6043 5.73938C22.3468 5.52145 22.0165 5.40863 21.6795 5.42345C21.3425 5.43827 21.0234 5.57964 20.786 5.81934L19.7362 6.86975C19.4965 7.10714 19.3552 7.42619 19.3403 7.76322C19.3255 8.10025 19.4383 8.43047 19.6563 8.68799C19.3649 9.50647 18.818 10.2579 18.6145 11.3418C18.6081 11.3588 18.5967 11.3734 18.5819 11.3838C18.5671 11.3942 18.5495 11.4 18.5314 11.4004C18.1953 11.4284 17.8821 11.5821 17.6543 11.8309C17.4266 12.0797 17.301 12.4053 17.3028 12.7425V14.2269C17.3011 14.5646 17.427 14.8904 17.6553 15.1393C17.8835 15.3881 18.1973 15.5416 18.5338 15.5691C18.5516 15.5698 18.5688 15.5759 18.5831 15.5864C18.5975 15.597 18.6084 15.6115 18.6144 15.6283C18.8207 16.7194 19.3655 17.463 19.6564 18.2814C19.4384 18.5389 19.3256 18.8691 19.3404 19.2062C19.3552 19.5433 19.4965 19.8623 19.7362 20.0997L20.7866 21.1508C21.0242 21.39 21.3432 21.531 21.6801 21.5456C22.0169 21.5602 22.3469 21.4473 22.6043 21.2295C22.6176 21.2172 22.6344 21.2092 22.6524 21.2066C22.6703 21.204 22.6887 21.2069 22.705 21.2149C23.4957 21.6984 24.3574 22.0549 25.2587 22.2714C25.2976 22.2789 25.319 22.3344 25.3197 22.377C25.3526 22.7087 25.5081 23.0163 25.7557 23.2395C26.0034 23.4627 26.3254 23.5854 26.6588 23.5836H28.1432C28.4809 23.5851 28.8068 23.4591 29.0556 23.2308C29.3044 23.0024 29.4579 22.6885 29.4854 22.3519C29.4862 22.3341 29.4924 22.3169 29.503 22.3025C29.5137 22.2882 29.5283 22.2773 29.5452 22.2714C30.4604 22.0092 31.3484 21.6601 32.1971 21.2287C32.4543 21.4475 32.7847 21.5609 33.122 21.5464C33.4593 21.5318 33.7786 21.3903 34.016 21.1502L35.0664 20.0997C35.3062 19.8622 35.4475 19.543 35.4623 19.2059C35.477 18.8687 35.364 18.5384 35.1458 18.2809C35.4381 17.4618 35.9844 16.7123 36.1876 15.6277C36.194 15.6106 36.2054 15.5959 36.2204 15.5854C36.2353 15.575 36.2531 15.5693 36.2713 15.5691C36.6074 15.5411 36.9206 15.3873 37.1484 15.1385C37.3761 14.8898 37.5016 14.5642 37.4999 14.2269V12.7426C37.5015 12.4049 37.3756 12.0791 37.1474 11.8302C36.9191 11.5814 36.6054 11.4279 36.2688 11.4004ZM36.2499 14.2269C36.25 14.2517 36.2406 14.2755 36.2237 14.2935C36.2068 14.3116 36.1836 14.3225 36.1589 14.324C35.88 14.3471 35.6154 14.4572 35.4024 14.6387C35.1894 14.8203 35.0388 15.0642 34.9718 15.336C34.7864 16.11 34.4803 16.85 34.0648 17.5289C33.9197 17.7685 33.8535 18.0475 33.8756 18.3267C33.8977 18.6059 34.0071 18.8711 34.1881 19.0847C34.204 19.1032 34.2123 19.1271 34.2112 19.1514C34.2102 19.1758 34.2 19.1989 34.1826 19.216L33.1322 20.2664C33.1148 20.2833 33.0918 20.2932 33.0675 20.2941C33.0433 20.295 33.0196 20.2868 33.001 20.2713C32.7873 20.0905 32.5222 19.9814 32.2432 19.9593C31.9642 19.9372 31.6853 20.0032 31.4458 20.148C30.767 20.5633 30.0272 20.8696 29.2534 21.0556C28.9811 21.1223 28.7367 21.273 28.5548 21.4865C28.373 21.6999 28.2629 21.9651 28.2402 22.2445C28.2382 22.2689 28.2271 22.2916 28.2091 22.3081C28.1911 22.3246 28.1676 22.3337 28.1432 22.3337H26.6588C26.6446 22.333 26.6307 22.3294 26.618 22.3232C26.6052 22.317 26.5938 22.3083 26.5845 22.2975C26.5753 22.2868 26.5682 22.2743 26.5639 22.2608C26.5596 22.2473 26.558 22.233 26.5593 22.2189C26.5322 21.9444 26.4205 21.6852 26.2398 21.4768C26.0591 21.2685 25.8183 21.1213 25.5504 21.0556C24.7762 20.8698 24.0359 20.5635 23.3568 20.148C23.117 20.0033 22.8379 19.9374 22.5587 19.9596C22.2795 19.9818 22.0143 20.091 21.8004 20.2719C21.782 20.2876 21.7582 20.2958 21.734 20.2948C21.7098 20.2938 21.6868 20.2836 21.6698 20.2664L20.62 19.216C20.6026 19.1989 20.5924 19.1758 20.5914 19.1514C20.5903 19.1271 20.5986 19.1032 20.6145 19.0847C20.7956 18.871 20.9049 18.6056 20.9269 18.3263C20.9489 18.047 20.8825 17.7678 20.7372 17.5283C20.322 16.8497 20.0159 16.1101 19.8302 15.3366C19.7636 15.0642 19.6129 14.8198 19.3994 14.638C19.186 14.4562 18.9207 14.3464 18.6412 14.324C18.6169 14.322 18.5943 14.3108 18.5779 14.2928C18.5615 14.2748 18.5525 14.2513 18.5527 14.2269V12.7426C18.5526 12.7178 18.562 12.694 18.5789 12.676C18.5958 12.6579 18.619 12.647 18.6437 12.6455C18.9225 12.6226 19.187 12.5126 19.3999 12.3311C19.6128 12.1496 19.7633 11.9058 19.8302 11.6342C20.0159 10.86 20.322 10.1198 20.7372 9.44057C20.8825 9.20116 20.9489 8.92209 20.9269 8.64288C20.9048 8.36367 20.7956 8.09845 20.6145 7.88478C20.5986 7.86628 20.5903 7.84244 20.5914 7.81807C20.5924 7.79371 20.6026 7.77064 20.62 7.75353L21.6698 6.70313C21.6868 6.68584 21.7097 6.67559 21.7339 6.67446C21.7582 6.67333 21.7819 6.68139 21.8004 6.69703C22.014 6.87843 22.2793 6.98802 22.5586 7.01026C22.838 7.0325 23.1172 6.96626 23.3568 6.82093C24.0362 6.40572 24.7763 6.09948 25.5504 5.91334C25.8183 5.84759 26.0591 5.7004 26.2398 5.49205C26.4205 5.2837 26.5321 5.02445 26.5593 4.75001C26.558 4.73591 26.5595 4.72168 26.5639 4.70819C26.5682 4.69471 26.5753 4.68225 26.5846 4.67157C26.5939 4.66089 26.6053 4.65222 26.618 4.64608C26.6308 4.63994 26.6447 4.63647 26.6588 4.63587H28.1432C28.168 4.63581 28.1919 4.64527 28.21 4.6623C28.228 4.67934 28.2389 4.70264 28.2402 4.72743C28.2635 5.00624 28.3737 5.27072 28.5552 5.48359C28.7368 5.69646 28.9806 5.84698 29.2522 5.91394C30.0261 6.09955 30.7661 6.40539 31.4452 6.82032C31.6846 6.96582 31.9637 7.03226 32.2429 7.01024C32.5222 6.98822 32.7874 6.87885 33.001 6.69764C33.0196 6.6819 33.0434 6.67372 33.0677 6.67474C33.092 6.67576 33.1151 6.68589 33.1322 6.70313L34.1827 7.75354C34.2 7.77053 34.2102 7.79344 34.2113 7.81766C34.2125 7.84188 34.2044 7.86564 34.1888 7.88417C34.0074 8.09764 33.8978 8.3628 33.8755 8.64205C33.8533 8.9213 33.9195 9.20046 34.0649 9.43995C34.4804 10.1196 34.7866 10.8602 34.9724 11.6348C35.0397 11.9066 35.1906 12.1505 35.404 12.3318C35.6173 12.5132 35.8823 12.6229 36.1614 12.6455C36.1857 12.6476 36.2083 12.6587 36.2247 12.6767C36.2411 12.6947 36.2501 12.7182 36.2499 12.7426V14.2269Z" fill="url(#paint1_linear_917_767)" />
                    <path d="M27.4016 7.56555C26.2309 7.56555 25.0865 7.9127 24.1131 8.56311C23.1397 9.21351 22.381 10.138 21.933 11.2196C21.485 12.3011 21.3678 13.4913 21.5962 14.6395C21.8246 15.7877 22.3883 16.8424 23.2161 17.6702C24.0439 18.4981 25.0986 19.0618 26.2468 19.2902C27.395 19.5186 28.5852 19.4014 29.6668 18.9534C30.7484 18.5054 31.6728 17.7467 32.3232 16.7733C32.9737 15.7999 33.3208 14.6554 33.3208 13.4847C33.3189 11.9155 32.6947 10.411 31.5851 9.30132C30.4754 8.19166 28.9709 7.56743 27.4016 7.56555ZM27.4016 18.1539C26.4782 18.1539 25.5754 17.8801 24.8076 17.367C24.0397 16.854 23.4413 16.1248 23.0879 15.2716C22.7344 14.4184 22.642 13.4796 22.8221 12.5738C23.0023 11.6681 23.447 10.8361 24.1 10.1831C24.753 9.53013 25.585 9.08543 26.4907 8.90526C27.3964 8.7251 28.3353 8.81756 29.1884 9.17096C30.0416 9.52436 30.7708 10.1228 31.2839 10.8907C31.797 11.6585 32.0708 12.5613 32.0708 13.4847C32.0694 14.7226 31.577 15.9094 30.7016 16.7848C29.8263 17.6601 28.6395 18.1525 27.4016 18.1539Z" fill="url(#paint2_linear_917_767)" />
                    <path d="M8.9353 20.5703C8.87728 20.5123 8.80839 20.4662 8.73257 20.4348C8.65675 20.4034 8.57548 20.3872 8.49341 20.3872C8.41133 20.3872 8.33007 20.4034 8.25424 20.4348C8.17842 20.4662 8.10953 20.5123 8.05151 20.5703L5.94092 22.6809C5.88287 22.739 5.83682 22.8078 5.8054 22.8837C5.77398 22.9595 5.75781 23.0408 5.75781 23.1228C5.75781 23.2049 5.77398 23.2862 5.8054 23.362C5.83682 23.4378 5.88287 23.5067 5.94092 23.5647L8.05151 25.6754C8.10955 25.7334 8.17844 25.7794 8.25426 25.8108C8.33008 25.8422 8.41134 25.8584 8.49341 25.8584C8.57548 25.8584 8.65674 25.8422 8.73256 25.8108C8.80838 25.7794 8.87727 25.7334 8.93531 25.6754C8.99334 25.6173 9.03937 25.5484 9.07077 25.4726C9.10218 25.3968 9.11834 25.3155 9.11834 25.2335C9.11834 25.1514 9.10218 25.0701 9.07077 24.9943C9.03937 24.9185 8.99333 24.8496 8.9353 24.7916L7.2666 23.1228L8.9353 21.4541C8.99335 21.3961 9.0394 21.3272 9.07082 21.2514C9.10224 21.1756 9.11841 21.0943 9.11841 21.0122C9.11841 20.9301 9.10224 20.8489 9.07082 20.773C9.0394 20.6972 8.99335 20.6283 8.9353 20.5703Z" fill="url(#paint3_linear_917_767)" />
                    <path d="M15.4389 24.7915C15.3217 24.9087 15.2559 25.0676 15.2559 25.2334C15.2559 25.3991 15.3217 25.5581 15.4389 25.6753C15.5561 25.7925 15.7151 25.8583 15.8808 25.8583C16.0465 25.8583 16.2055 25.7925 16.3227 25.6753L18.4333 23.5647C18.4914 23.5066 18.5374 23.4378 18.5688 23.3619C18.6002 23.2861 18.6164 23.2048 18.6164 23.1228C18.6164 23.0407 18.6002 22.9594 18.5688 22.8836C18.5374 22.8078 18.4914 22.7389 18.4333 22.6809L16.3227 20.5702C16.2647 20.5122 16.1958 20.4662 16.1199 20.4348C16.0441 20.4034 15.9629 20.3872 15.8808 20.3872C15.7987 20.3872 15.7175 20.4034 15.6416 20.4348C15.5658 20.4662 15.4969 20.5122 15.4389 20.5702C15.3809 20.6283 15.3348 20.6972 15.3034 20.773C15.272 20.8488 15.2559 20.9301 15.2559 21.0121C15.2559 21.0942 15.272 21.1755 15.3034 21.2513C15.3348 21.3271 15.3809 21.396 15.4389 21.454L17.1076 23.1227L15.4389 24.7915Z" fill="url(#paint4_linear_917_767)" />
                    <path d="M12.1085 20.8608L11.0538 25.082C11.0339 25.1616 11.0299 25.2443 11.042 25.3255C11.0541 25.4066 11.082 25.4846 11.1243 25.5549C11.1665 25.6253 11.2221 25.6866 11.2881 25.7354C11.354 25.7842 11.4289 25.8196 11.5085 25.8395C11.5881 25.8594 11.6708 25.8634 11.7519 25.8513C11.8331 25.8392 11.9111 25.8112 11.9814 25.769C12.0517 25.7268 12.1131 25.6711 12.1619 25.6052C12.2107 25.5392 12.2461 25.4643 12.2659 25.3848L13.3206 21.1636C13.3573 21.0041 13.3299 20.8366 13.2444 20.697C13.1588 20.5575 13.0219 20.4571 12.8631 20.4174C12.7043 20.3778 12.5363 20.402 12.3952 20.4849C12.2541 20.5678 12.1511 20.7028 12.1085 20.8608Z" fill="url(#paint5_linear_917_767)" />
                    <defs>
                      <linearGradient id="paint0_linear_917_767" x1="19.1126" y1="7.2915" x2="19.1126" y2="36.6098" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#195AFF" />
                        <stop offset="1" stopColor="#0F3699" />
                      </linearGradient>
                      <linearGradient id="paint1_linear_917_767" x1="27.4013" y1="3.38586" x2="27.4013" y2="23.5836" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#195AFF" />
                        <stop offset="1" stopColor="#0F3699" />
                      </linearGradient>
                      <linearGradient id="paint2_linear_917_767" x1="27.4016" y1="7.56555" x2="27.4016" y2="19.4039" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#195AFF" />
                        <stop offset="1" stopColor="#0F3699" />
                      </linearGradient>
                      <linearGradient id="paint3_linear_917_767" x1="7.43811" y1="20.3872" x2="7.43811" y2="25.8584" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#195AFF" />
                        <stop offset="1" stopColor="#0F3699" />
                      </linearGradient>
                      <linearGradient id="paint4_linear_917_767" x1="16.9361" y1="20.3872" x2="16.9361" y2="25.8583" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#195AFF" />
                        <stop offset="1" stopColor="#0F3699" />
                      </linearGradient>
                      <linearGradient id="paint5_linear_917_767" x1="12.1858" y1="20.3988" x2="12.1858" y2="25.8581" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#195AFF" />
                        <stop offset="1" stopColor="#0F3699" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <div>
                  <p className="text-[18px] text-[#090D28] font-semibold font-Schibsted_Grotesk">100% Custom-Built Solutions</p>
                </div>
                <div>
                  <p className="text-[#717277] text-[14px] font-Schibsted_Grotesk">
                    We don’t sell templates or pre-made products. Every solution is tailored to your business goals, industry, and tech needs.
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white p-[20px] rounded-[16px]  shadow-md">
              <div className="flex flex-col space-y-[8px]">
                <div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                    <g clipPath="url(#clip0_917_778)">
                      <path d="M19.6185 13.0274L14.8105 17.5687L12.503 15.1947C12.2472 14.9314 11.826 14.9254 11.5629 15.1812C11.2995 15.4373 11.2935 15.8582 11.5493 16.1216L14.3168 18.9626C14.574 19.2213 14.9895 19.2301 15.2572 18.9824L20.5456 13.9944C20.674 13.8732 20.7491 13.706 20.754 13.5296C20.759 13.3533 20.6936 13.1821 20.5722 13.054C20.3148 12.7864 19.8905 12.7747 19.6185 13.0274Z" fill="url(#paint0_linear_917_778)" />
                      <path d="M16.0509 6.0387C10.556 6.0387 6.08789 10.5068 6.08789 16.0017C6.08789 21.4969 10.556 25.965 16.0509 25.965C21.5461 25.965 26.0142 21.4969 26.0142 16.0017C26.0142 10.5068 21.5461 6.0387 16.0509 6.0387ZM16.0509 24.6312C11.2895 24.6312 7.42164 20.7566 7.42164 16.0017C7.42164 11.2468 11.2895 7.37245 16.0509 7.37245C20.817 7.37245 24.6804 11.2359 24.6804 16.0017C24.6804 20.7675 20.817 24.6312 16.0509 24.6312Z" fill="url(#paint1_linear_917_778)" />
                      <path d="M29.7626 12.3335L29.9827 8.37888C29.9981 8.11343 29.8538 7.86414 29.6159 7.74535L26.0948 5.96484L24.3143 2.44369C24.1932 2.20794 23.9454 2.06441 23.6808 2.07691L19.7194 2.29052L16.4183 0.109629C16.1959 -0.0370313 15.9075 -0.0370313 15.6848 0.109629L12.3837 2.29052L8.42937 2.0704C8.16367 2.05477 7.91463 2.19908 7.79584 2.43718L6.01508 5.95833L2.49419 7.73884C2.25818 7.85971 2.1149 8.10744 2.1274 8.37237L2.34727 12.327L0.166636 15.628C0.0199755 15.8505 0.0199755 16.1389 0.166636 16.3616L2.34075 19.6691L2.12063 23.6237C2.10526 23.8892 2.24932 24.1385 2.48741 24.2573L6.00857 26.0378L7.78907 29.5589C7.90994 29.7949 8.15767 29.9382 8.4226 29.9257L12.3772 29.7056L15.6783 31.8862C15.8994 32.0376 16.1907 32.0376 16.4118 31.8862L19.7128 29.7056L23.6675 29.9257C23.9329 29.9411 24.182 29.7968 24.301 29.5589L26.0815 26.0378L29.6027 24.2573C29.8384 24.1361 29.9819 23.8887 29.9694 23.6237L29.7493 19.6691L31.9299 16.3681C32.0766 16.1456 32.0766 15.857 31.9299 15.6345L29.7626 12.3335ZM28.5221 19.1223C28.4408 19.2416 28.4031 19.3852 28.4156 19.5292L28.6221 23.2703L25.2945 24.9507C25.1677 25.0143 25.0648 25.1174 25.0012 25.2443L23.3205 28.5719L19.5795 28.3653C19.4362 28.3601 19.2948 28.3971 19.1726 28.4719L16.0515 30.5327L12.9308 28.4719C12.8224 28.3987 12.6948 28.3591 12.564 28.3586H12.5307L8.78938 28.5654L7.10891 25.2375C7.04535 25.1107 6.94245 25.0078 6.81533 24.9442L3.48095 23.2703L3.68779 19.5292C3.693 19.386 3.65575 19.2445 3.58098 19.1223L1.52044 16.0013L3.58098 12.8803C3.66252 12.7612 3.70029 12.6174 3.68779 12.4736L3.48095 8.73238L6.80882 7.0519C6.93568 6.98834 7.03858 6.88544 7.10214 6.75858L8.78261 3.43072L12.5239 3.63755C12.6669 3.6425 12.8083 3.60551 12.9308 3.53075L16.0515 1.47021L19.1726 3.53075C19.2919 3.61229 19.4357 3.65006 19.5795 3.63755L23.3205 3.43072L25.0012 6.75858C25.0648 6.88544 25.1677 6.98834 25.2945 7.0519L28.6221 8.73238L28.4156 12.4736C28.4104 12.6167 28.4476 12.7581 28.5221 12.8803L30.5829 16.0013L28.5221 19.1223Z" fill="url(#paint2_linear_917_778)" />
                    </g>
                    <defs>
                      <linearGradient id="paint0_linear_917_778" x1="16.0578" y1="12.8453" x2="16.0578" y2="19.1625" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#195AFF" />
                        <stop offset="1" stopColor="#0F3699" />
                      </linearGradient>
                      <linearGradient id="paint1_linear_917_778" x1="16.051" y1="6.0387" x2="16.051" y2="25.965" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#195AFF" />
                        <stop offset="1" stopColor="#0F3699" />
                      </linearGradient>
                      <linearGradient id="paint2_linear_917_778" x1="16.0483" y1="-0.000366211" x2="16.0483" y2="31.9997" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#195AFF" />
                        <stop offset="1" stopColor="#0F3699" />
                      </linearGradient>
                      <clipPath id="clip0_917_778">
                        <rect width="32" height="32" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div>
                  <p className="text-[18px] text-[#090D28] font-semibold font-Schibsted_Grotesk">Enterprise Quality, Without Enterprise Cost</p>
                </div>
                <div>
                  <p className="text-[#717277] text-[14px] font-Schibsted_Grotesk">
                    Get world-class design, engineering, and delivery at a fraction of the traditional agency cost.
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white p-[20px] rounded-[16px]  shadow-md">
              <div className="flex flex-col space-y-[8px]">
                <div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                    <g clipPath="url(#clip0_917_786)">
                      <path d="M29 0H3C1.3457 0 0 1.3457 0 3V15.3496C0 15.9023 0.44775 16.3496 1 16.3496C1.55225 16.3496 2 15.9023 2 15.3496V3C2 2.44824 2.44873 2 3 2H29C29.5513 2 30 2.44824 30 3V29C30 29.5518 29.5513 30 29 30H16.6499C16.0977 30 15.6499 30.4473 15.6499 31C15.6499 31.5527 16.0977 32 16.6499 32H29C30.6543 32 32 30.6543 32 29V3C32 1.3457 30.6543 0 29 0Z" fill="url(#paint0_linear_917_786)" />
                      <path d="M11 18H3C1.3457 18 0 19.3457 0 21V29C0 30.6543 1.3457 32 3 32H11C12.6543 32 14 30.6543 14 29V21C14 19.3457 12.6543 18 11 18ZM12 29C12 29.5518 11.5513 30 11 30H3C2.44873 30 2 29.5518 2 29V21C2 20.4482 2.44873 20 3 20H11C11.5513 20 12 20.4482 12 21V29Z" fill="url(#paint1_linear_917_786)" />
                      <path d="M16.707 16.707L23 10.4141V12C23 12.5527 23.4478 13 24 13C24.5522 13 25 12.5527 25 12V8C25 7.46432 24.544 7 24 7H20C19.4478 7 19 7.44727 19 8C19 8.55273 19.4478 9 20 9H21.5859L15.293 15.293C14.9023 15.6836 14.9023 16.3164 15.293 16.707C15.6705 17.0846 16.3173 17.0968 16.707 16.707Z" fill="url(#paint2_linear_917_786)" />
                    </g>
                    <defs>
                      <linearGradient id="paint0_linear_917_786" x1="16" y1="0" x2="16" y2="32" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#195AFF" />
                        <stop offset="1" stopColor="#0F3699" />
                      </linearGradient>
                      <linearGradient id="paint1_linear_917_786" x1="7" y1="18" x2="7" y2="32" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#195AFF" />
                        <stop offset="1" stopColor="#0F3699" />
                      </linearGradient>
                      <linearGradient id="paint2_linear_917_786" x1="20" y1="7" x2="20" y2="16.9948" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#195AFF" />
                        <stop offset="1" stopColor="#0F3699" />
                      </linearGradient>
                      <clipPath id="clip0_917_786">
                        <rect width="32" height="32" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div>
                  <p className="text-[18px] text-[#090D28] font-semibold font-Schibsted_Grotesk">Scalable and Secure Architecture</p>
                </div>
                <div>
                  <p className="text-[#717277] text-[14px] font-Schibsted_Grotesk">
                    From MVPs to enterprise-grade systems — our solutions are future-proof and built to grow with you.
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white p-[20px] rounded-[16px]  shadow-md">
              <div className="flex flex-col space-y-[8px]">
                <div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <path fillRule="evenodd" clipRule="evenodd" d="M20.8836 19.1169C20.8836 19.1169 18.4419 16.6736 16.0002 14.2336C12.8186 11.0502 7.6569 11.0502 4.47523 14.2336L4.47023 14.2369C1.28857 17.4202 1.28857 22.5802 4.47023 25.7636L4.47523 25.7669C7.6569 28.9502 12.8186 28.9502 16.0002 25.7669C16.5252 25.2419 17.0502 24.7186 17.5502 24.2169C18.0386 23.7302 18.0386 22.9369 17.5502 22.4502C17.0636 21.9619 16.2702 21.9619 15.7836 22.4502C15.2819 22.9502 14.7586 23.4752 14.2336 24.0002C12.0269 26.2069 8.44857 26.2069 6.2419 24.0002L6.23857 23.9952C4.0319 21.7886 4.0319 18.2119 6.23857 16.0052L6.2419 16.0002C8.44857 13.7936 12.0269 13.7936 14.2336 16.0002C16.6736 18.4419 19.1169 20.8836 19.1169 20.8836C19.6036 21.3719 20.3969 21.3719 20.8836 20.8836C21.3719 20.3969 21.3719 19.6036 20.8836 19.1169Z" fill="url(#paint0_linear_917_794)" />
                    <path fillRule="evenodd" clipRule="evenodd" d="M24.2162 17.5502C24.7179 17.0502 25.2413 16.5252 25.7662 16.0002C27.9729 13.7936 31.5512 13.7936 33.7579 16.0002C33.7579 16.0019 33.7596 16.0036 33.7613 16.0052C35.9679 18.2119 35.9679 21.7886 33.7613 23.9952C33.7596 23.9969 33.7579 23.9986 33.7579 24.0002C31.5512 26.2069 27.9729 26.2069 25.7662 24.0002C23.3262 21.5586 20.8829 19.1169 20.8829 19.1169C20.3962 18.6286 19.6029 18.6286 19.1163 19.1169C18.6279 19.6036 18.6279 20.3969 19.1163 20.8836C19.1163 20.8836 21.5579 23.3269 23.9996 25.7669C27.1812 28.9502 32.3429 28.9502 35.5246 25.7669C35.5263 25.7652 35.5279 25.7652 35.5296 25.7636C38.7113 22.5802 38.7113 17.4202 35.5296 14.2369C35.5279 14.2352 35.5263 14.2352 35.5246 14.2336C32.3429 11.0502 27.1812 11.0502 23.9996 14.2336C23.4746 14.7586 22.9496 15.2819 22.4496 15.7836C21.9613 16.2702 21.9613 17.0636 22.4496 17.5502C22.9363 18.0386 23.7296 18.0386 24.2162 17.5502Z" fill="url(#paint1_linear_917_794)" />
                    <defs>
                      <linearGradient id="paint0_linear_917_794" x1="11.6669" y1="11.8461" x2="11.6669" y2="28.1544" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#195AFF" />
                        <stop offset="1" stopColor="#0F3699" />
                      </linearGradient>
                      <linearGradient id="paint1_linear_917_794" x1="28.3329" y1="11.8461" x2="28.3329" y2="28.1544" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#195AFF" />
                        <stop offset="1" stopColor="#0F3699" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <div>
                  <p className="text-[18px] text-[#090D28] font-semibold font-Schibsted_Grotesk">Long-Term Support & Maintenance</p>
                </div>
                <div>
                  <p className="text-[#717277] text-[14px] font-Schibsted_Grotesk">
                    We don’t disappear after launch. Get consistent updates, bug fixes, scaling support, and ongoing optimization.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="w-full min-h-screen bg-white flex items-center justify-center px-6 py-16">
        <div className="max-w-7xl">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
            {projects.map((project, i) => (
              <div key={i} className="flex flex-col space-y-3">
                <div className="w-full aspect-square rounded-lg  overflow-hidden">
                  <Image
                    src={project.img}
                    alt={project.title}
                    width={200}
                    height={200}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="space-y-[8px]">
                  <h3 className="text-[#090D28] font-semibold text-[18px] font-Schibsted_Grotesk">
                    {project.title}
                  </h3>
                  <p className="text-[#000]/70 text-[16px] font-Schibsted_Grotesk">{project.desc}</p>
                  <p className="text-[#0062FF] text-[14px] font-[500] font-Schibsted_Grotesk">
                    {project.highlight}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>



      <section className="bg-[#01001E]  py-[60px] relative overflow-hidden">

        <h4 className="text-white z-50 relative text-center text-[32px] md:text-[48px] font-extrabold leading-[120%] font-NeueMontreal">We Make for Your Team  </h4>
        <p className="text-[#c4c4c4] z-50 relative text-center text-[16px] md:text-[18px] font-normal leading-[150%] font-Schibsted_Grotesk py-4">Our team ensures timely results without compromising quality</p>
        <section className='flex items-center justify-center gap-3 '>
          <TestiReviewCommonImages />
          <div>
            <a
              href='https://maps.app.goo.gl/wxZr7ckDhrWnVbx27'
              className='text-[#090D28]'
              target='_blank'
            >
              {' '}
              <p className=' m-0 flex items-center gap-1 p-0 pb-[6px] text-center font-LatinkaRegular text-sm font-normal leading-[120%] text-white'>
                <Image className='w-6' src={getImageUrl("/vilvabusiness/website/common/homepage/google-img.webp")} width={50} height={50} quality={75} alt='GoogleImg' />{' '}
                Google Reviews
              </p>
            </a>
            <div className='flex items-center gap-2 text-white'>
              4.7
              <div className='flex items-center gap-2'>
                <SvgIcons.ReviewStar />
                <SvgIcons.ReviewStar />
                <SvgIcons.ReviewStar />
                <SvgIcons.ReviewStar />
                <SvgIcons.ReviewStar />
              </div>
            </div>
          </div>
        </section>
        <div className="relative z-50">
          <StatsSection />

        </div>


      </section>


      <section className="pb-[60px] md:pb-[120px] px-4 md:px-0 md:container">
        {/* <h2 className="text-[#090D28] text-center md:text-[] text-[32px] w-full mx-auto whitespace-normal md:whitespace-nowrap md:text-[40px] font-extrabold leading-[120%] font-NeueMontreal">
                      Your questions Our Answers
                    </h2> */}
        <FaqSection faqs={faqs} />
      </section>


    </div>
  )
}